// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__255gX","select":"Header_select__12DfI","clinic":"Header_clinic__2usFI"};